import { RiArticleLine } from "@remixicon/react";
import classNames from "classnames";
import React from "react";
import {
    ArticlePreview,
} from "../../../../__generated__/api";
import Icon from "../../../../components/theme/icon/Icon";
import Text from "../../../../components/theme/text/Text";
import Styles from "./RelatedArticles.module.scss";
import Link from "../../../../components/theme/button/Link";
import RouterLink from "../../../../components/theme/button/RouterLink";
import { Paths } from "../../../../contexts/Routing";
import { LoggingHandler } from "../../../../contexts/logging/LoggingContext";

export default function RelatedArticles({ articles }: {articles: ArticlePreview[]}) {
    return (
        <div className={Styles["related-articles"]}>
            {articles.map(article => {
                const body = (
                    <>
                        <Icon
                            background="primary"
                            size="xlarge"
                            isRounded
                            variant="primary"
                            className={Styles["related-bar-icon"]}
                            icon={<RiArticleLine />}
                        />

                        <Text textVariant="body-1-semibold" colorVariant="text-title" className={Styles["related-block-header"]}>
                            {article.title}
                        </Text>

                        <Text
                            className={Styles["related-block-preview"]}
                            textVariant="body-2-regular"
                            colorVariant="body-secondary"
                        >
                            {article.previewText}
                        </Text>
                    </>
                );

                return (
                    article.url
                        ? (
                            <Link
                                className={Styles["articles-block"]}
                                href={article.url}
                                rel=""
                                key={article.id}
                                metricPath={[LoggingHandler.Metrics.ARTICLES, "related-articles", article.id]}
                            >
                                {body}
                            </Link>
                        )
                        : (
                            <RouterLink
                                to={Paths.ANSWERS_GET}
                                params={{ id: article.id }}
                                key={article.id}
                                className={Styles["articles-block"]}
                                metricPath={[LoggingHandler.Metrics.ARTICLES, "related-articles", article.id]}
                            >
                                {body}
                            </RouterLink>
                        )

                );
            })}
        </div>

    );
}
